import { types } from "@gadgetinc/mobx-quick-tree";

export const OkStatus = "ok";
export const WarningStatus = "warning";
export const ExceededStatus = "exceeded";

export const DefaultStatus = OkStatus;

export const UsageThresholdStatuses = [OkStatus, WarningStatus, ExceededStatus] as const;
export const isUsageThresholdStatus = (status: string): status is UsageThresholdStatus =>
  (UsageThresholdStatuses as readonly string[]).includes(status);

export type UsageThresholdStatus = (typeof UsageThresholdStatuses)[number];
export const UsageThresholdStatusMSTType = types.optional(types.frozen<UsageThresholdStatus>(), DefaultStatus);
